import "bootstrap/dist/css/bootstrap.css";
import "react-loading-skeleton/dist/skeleton.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/800.css";

import React from "react";
import { createRoot } from "react-dom/client";
import Router from "./config/router";
import "./config/i18n";

import "./assets/css/global.css";
import './styles/tokens.scss'
import './styles/colors.scss'
import './styles/typography.scss'

createRoot(document.getElementById("root") as HTMLElement).render(<Router />);
